import script from "./AddNoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNoteForm.vue?vue&type=script&setup=true&lang=js"

import "./AddNoteForm.vue?vue&type=style&index=0&id=2dc7a882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc7a882"]])

export default __exports__